import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * 버튼
 */
const ButtonUnderText = ({ label, value, labelIcon, alt, styleDef, viewStatus, onClickEvt, title, error, image }) => {

  return (
    <div className="_btn_under_txt_div" style={styleDef} onClick={onClickEvt}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <button type="button" className="_btn_div" title={title}>
        <div className="_icon"> 
          {labelIcon !== 'ri-cloud-line' ? (
            <i className={labelIcon} />
          ) : (
            <div> {image.includes('<img') ? ReactHtmlParser(image.replace("<img", `<img alt='${alt}'`)) : <img src={image} alt={alt} />}</div>
          )}
        </div>
        <div className="_txt" style={styleDef}>{label}</div>
      </button>
    </div>
  );
};

ButtonUnderText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  labelIcon: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  onClickEvt: PropTypes.func,
  error: PropTypes.object,
};
ButtonUnderText.defaultProps = {
  label: '적용',
  value: '',
  image: '',
  alt: '',
  title: '',
  labelIcon: 'ri-cloud-line',
  styleDef: {},
  viewStatus: '',
  onClickEvt: () => {},
  error: { error: false, msg: '' },
};

export default ButtonUnderText;
